/**
 * Requested feature to scroll to the top of the page for when embedded in another site
 */
export const scrollRootToTop = () => {
    const root = document.getElementById('rapidstor-v2-frontend');
    if (root) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
};

export const fadeIn = () => {
    const RSContainer = document.getElementById(
        'rapidstor-v2-frontend',
    ) as HTMLElement;
    RSContainer.style.opacity = '1';
};

export const fadeOut = () => {
    const RSContainer = document.getElementById(
        'rapidstor-v2-frontend',
    ) as HTMLElement;
    RSContainer.style.opacity = '0';
};

export const replace = (
    string: string,
    replacements: Record<string, string>,
) => Object.keys(replacements).reduce((acc, key) => acc.replace(key, replacements[key]), string);
